import React from "react";
import { trackEvent } from "/services/bigbrain-service";
import * as Sentry from "@sentry/nextjs";

export const trackMutinyConversion = (eventName) => {
  if (window?.mutiny?.client) {
    window.mutiny.client.trackConversion({ name: eventName });
  }
};

const syncExperienceToAbTest = (mutinyExperience) => {
  if (!mutinyExperience) return;

  console.log("syncExperienceToAbTest:", mutinyExperience);
  try {
    const testName = mutinyExperience?.experience;
    let variantName = mutinyExperience?.impressionType;
    if (mutinyExperience?.variationName) {
      variantName = `${variantName}-${mutinyExperience?.variationName}`;
    }
    trackEvent(testName, { ab_test: variantName });
  } catch (err) {
    console.error("Mutiny Sync error", err.message);
    Sentry.captureException(err);
  }
};

export const syncMutinyTestsToBigBrain = () => {
  if (!window.mutiny) return;

  if (window.mutiny.experiences) {
    window.mutiny.experiences.forEach((experience) => syncExperienceToAbTest(experience));
  }
};
const experienceSyncToBigBrain = (event) => {
  console.log("experienceSyncToBigBrain is live");
  syncExperienceToAbTest(event?.detail);
};

export const addMutinyAbTestSyncListener = () => {
  if (!window.mutiny) return;

  window.addEventListener("mutiny:experience-impression", experienceSyncToBigBrain);
};

export const removeMutinyAbTestSyncListener = () => {
  if (!window.mutiny) return;

  window.removeEventListener("mutiny:experience-impression", experienceSyncToBigBrain);
};

const MutinyScript = () => {
  const mutinyScript = () => {
    return `
      (function()
      {var a=window.mutiny=window.mutiny||{};if(!window.mutiny.client){a.client={_queue:{}};var b=["identify","trackConversion"];var c=[].concat(b,["defaultOptOut","optOut","optIn"]);var d=function factory(c){return function(){for(var d=arguments.length,e=new Array(d),f=0;f<d;f++){e[f]=arguments[f]}a.client._queue[c]=a.client._queue[c]||[];if(b.includes(c)){return new Promise(function(b,d){a.client._queue[c].push({args:e,resolve:b,reject:d});setTimeout(d,500)})}else{a.client._queue[c].push({args:e})}}};c.forEach(function(b){a.client[b]=d(b)})}})();`;
  };

  return (
    <>
      <script
        dangerouslySetInnerHTML={{
          __html: mutinyScript()
        }}
      />
      <script data-cfasync="false" src="https://client-registry.mutinycdn.com/personalize/client/9757076507ec4533.js" />
    </>
  );
};

export default MutinyScript;
